import { defineMessages } from 'react-intl';

export const baseUrl = 'https://circleci.com';
export const innerAppUrl = 'https://app.circleci.com';
const externalScope = 'links.external';
const internalScope = 'links.internal';
const socialScope = 'links.social';

const productLinks = {
  home: {
    id: `${externalScope}.home`,
    defaultMessage: `${baseUrl}/`,
  },
  signup: {
    id: `${externalScope}.signup`,
    defaultMessage: `${baseUrl}/signup/`,
  },
  pricing: {
    id: `${externalScope}.pricing`,
    defaultMessage: `${baseUrl}/pricing/`,
  },
};

const supportLinks = {
  docs: {
    id: `${externalScope}.docs`,
    defaultMessage: `${baseUrl}/docs/`,
  },
  imageDocs: {
    id: `${externalScope}.imageDocs`,
    defaultMessage: `${baseUrl}/docs/circleci-images`,
  },
  machineDocs: {
    id: `${externalScope}.machineDocs`,
    defaultMessage: `${baseUrl}/docs/executor-types?section=executors-and-images#using-machine`,
  },
  privateOrb: {
    id: `${externalScope}.privateOrb`,
    defaultMessage: `${baseUrl}/docs/orb-intro`,
  },
  orbDocs: {
    id: `${externalScope}.orbDocs`,
    defaultMessage: `${baseUrl}/docs/orb-intro`,
  },
};

const socialLinks = {
  blogFeed: {
    id: `${socialScope}.blogFeed`,
    defaultMessage: `${baseUrl}/blog/feed.xml`,
  },
  facebook: {
    id: `${socialScope}.facebook`,
    defaultMessage: 'https://www.facebook.com/circleci',
  },
  twitter: {
    id: `${socialScope}.twitter`,
    defaultMessage: 'https://twitter.com/circleci',
  },
  github: {
    id: `${socialScope}.github`,
    defaultMessage: 'https://github.com/circleci',
  },
  linkedIn: {
    id: `${socialScope}.linkedIn`,
    defaultMessage: 'https://www.linkedin.com/company/circleci',
  },
};

const legalLinks = {
  termsOfUse: {
    id: `${externalScope}.termsOfUse`,
    defaultMessage: `${baseUrl}/legal/terms-of-use/`,
  },
  privacyPolicy: {
    id: `${externalScope}.privacyPolicy`,
    defaultMessage: `${baseUrl}/privacy/`,
  },
  cookiePolicy: {
    id: `${externalScope}.cookiePolicy`,
    defaultMessage: `${baseUrl}/legal/cookie-policy/`,
  },
  security: {
    id: `${externalScope}.security`,
    defaultMessage: `${baseUrl}/security/`,
  },
};

const homePage_hero = {
  getStarted: {
    id: `${externalScope}.getStarted`,
    defaultMessage: `${baseUrl}/changelog/`,
  },
  signUp: {
    id: `${externalScope}.signUp`,
    defaultMessage: `${baseUrl}/integrations/`,
  },
};

const homePage_learnCCI_gettingStarted = {
  quickstartGuide: {
    id: `${externalScope}.quickstartGuide`,
    defaultMessage: `${baseUrl}/docs/getting-started/`,
  },
  onDemandCourse: {
    id: `${externalScope}.onDemandCourse`,
    defaultMessage: `${baseUrl}/training/`,
  },
  examplesGuides: {
    id: `${externalScope}.examplesGuides`,
    defaultMessage: `${baseUrl}/docs/examples-and-guides-overview/`,
  },
};

const homePage_learnCCI_config = {
  configIntro: {
    id: `${externalScope}.configIntro`,
    defaultMessage: `${baseUrl}/docs/config-intro/`,
  },
  sampleConfig: {
    id: `${externalScope}.sampleConfig`,
    defaultMessage: `${baseUrl}/docs/sample-config/`,
  },
  configReference: {
    id: `${externalScope}.configReference`,
    defaultMessage: `${baseUrl}/docs/configuration-reference/`,
  },
};

const homePage_learnCCI_tools = {
  orbsIntro: {
    id: `${externalScope}.orbsIntro`,
    defaultMessage: `${baseUrl}/docs/orb-intro/`,
  },
  nodeOrb: {
    id: `${internalScope}.nodeOrb`,
    defaultMessage: `${baseUrl}/developer/orbs/orb/circleci/node/`,
  },
  androidImage: {
    id: `${internalScope}.androidImage`,
    defaultMessage: `${baseUrl}/developer/images/image/cimg/android/`,
  },
};

const homePage_learnCCI_whatsNew = {
  tokens: {
    id: `${externalScope}.tokens`,
    defaultMessage: `${baseUrl}/docs/openid-connect-tokens/`,
  },
  macOS: {
    id: `${externalScope}.macOS`,
    defaultMessage: `${baseUrl}/changelog/#new-macos-cloud-ips/`,
  },
  IP: {
    id: `${externalScope}.IP`,
    defaultMessage: `${baseUrl}/docs/ip-ranges/#circleci-macos-cloud/`,
  },
};

const homePage_orbs = {
  orbFeature: {
    id: `${internalScope}.orbFeature`,
    defaultMessage: `${baseUrl}/developer/orbs`,
  },
  slack: {
    id: `${internalScope}.slack`,
    defaultMessage: `${baseUrl}/developer/orbs/orb/circleci/slack/`,
  },
  aws: {
    id: `${internalScope}.aws`,
    defaultMessage: `${baseUrl}/developer/orbs?query=aws&page=1&pageSize=15&filterBy=certifiedAndPartner/`,
  },
  node: {
    id: `${internalScope}.node`,
    defaultMessage: `${baseUrl}/developer/orbs/orb/circleci/node/`,
  },
};

const homePage_insights = {
  insightsFeatureLoggedIn: {
    id: `${externalScope}.insightsFeatureLoggedIn`,
    defaultMessage: `${innerAppUrl}/insights`,
  },
  insightsFeatureLoggedOut: {
    id: `${externalScope}.insightsFeatureLoggedOut`,
    defaultMessage: `${baseUrl}/docs/insights`,
  },
  responseTime: {
    id: `${externalScope}.responseTime`,
    defaultMessage: `${baseUrl}/docs/optimizations/`,
  },
  credits: {
    id: `${externalScope}.credits`,
    defaultMessage: `${baseUrl}/docs/insights-glossary/?highlight#organization-level-metrics/`,
  },
  tests: {
    id: `${externalScope}.tests`,
    defaultMessage: `${baseUrl}/docs/test-splitting-tutorial/`,
  },
};

const homePage_helpfulResources = {
  newFeatures: {
    id: `${externalScope}.newFeatures`,
    defaultMessage: `${baseUrl}/changelog/`,
  },
  integrations: {
    id: `${externalScope}.integrations`,
    defaultMessage: `${baseUrl}/integrations/`,
  },
  languageGuides: {
    id: `${externalScope}.languageGuides`,
    defaultMessage: `${baseUrl}/docs/examples-and-guides-overview/`,
  },
  webhooks: {
    id: `${externalScope}.webhooks`,
    defaultMessage: `${baseUrl}/docs/webhooks/`,
  },
};

export default defineMessages({
  root: {
    id: `${externalScope}.root`,
    defaultMessage: `${baseUrl}/`,
  },
  ...legalLinks,
  ...productLinks,
  ...socialLinks,
  ...supportLinks,
  ...homePage_hero,
  ...homePage_learnCCI_gettingStarted,
  ...homePage_learnCCI_config,
  ...homePage_learnCCI_tools,
  ...homePage_learnCCI_whatsNew,
  ...homePage_orbs,
  ...homePage_insights,
  ...homePage_helpfulResources,
});
